/* tslint:disable */
/* eslint-disable */
/**
 * zbo-connector API
 * zbo-connector - client
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
*
* @export
* @enum {string}
*/
export var EnumZboTypSubjektu;
(function (EnumZboTypSubjektu) {
    EnumZboTypSubjektu["FO"] = "FO";
    EnumZboTypSubjektu["FOP"] = "FOP";
    EnumZboTypSubjektu["PO"] = "PO";
})(EnumZboTypSubjektu || (EnumZboTypSubjektu = {}));
//# sourceMappingURL=enum-zbo-typ-subjektu.js.map